import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=0e991cfc&scoped=true"
import script from "./RejectModal.vue?vue&type=script&lang=js"
export * from "./RejectModal.vue?vue&type=script&lang=js"
import style0 from "./RejectModal.vue?vue&type=style&index=0&id=0e991cfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e991cfc",
  null
  
)

export default component.exports